var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail" },
    [
      _c("div", { staticClass: "detail-title" }, [_vm._v("账单详情：")]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            loading: _vm.detailLoading,
            data: _vm.detailData,
            "max-height": 300,
            "tooltip-effect": "dark"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", prop: "serialNum", width: "120" }
          }),
          _vm._v(" "),
          _vm.showStatus
            ? _c("el-table-column", {
                attrs: { label: "状态", prop: "processStatus", width: "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterProcessStatus")(
                                  scope.row.processStatus
                                )
                              )
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2870666655
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "salesOrderNo",
              label: "销售单号/售后单号",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.corpFlag === 1
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#FF4D28",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleBtn(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.salesOrderNo))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.corpFlag === 0
                      ? _c("span", [_vm._v(_vm._s(scope.row.salesOrderNo))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "orderTypeDesc", label: "单据类型" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "skuCode", label: "商品编码" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "skuName", label: "商品名称", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "purchaseQuantity", label: "数量", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "purchasePrice", label: "采购单价", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "purchaseAmount",
              label: "采购金额/采退金额",
              width: "120"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "settle-modal",
          attrs: {
            visible: _vm.orderDialogVisible,
            width: "80%",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.orderDialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_c("span", { staticClass: "title" }, [_vm._v("查看原单")])]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleClose("originOrderModal")
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: { data: _vm.originalOrderList, border: "", height: "100" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "原单", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "confirmDate", label: "售后确认日期" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "saleOrder", label: "售后单号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuCode", label: "商品编码" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuName", label: "商品名称" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "originalQuantity", label: "原数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "unDeductQuantity", label: "待抵扣数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "purchasePrice", label: "采购单价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "originalTotalAmount", label: "原总价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "unDeductTotalAmount", label: "待抵扣总价" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: { data: _vm.deductionOrderList, border: "", height: "100" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "抵扣单", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "confirmTime", label: "结算单确认日期" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "settleNo", label: "结算单" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "amount2" } }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "amount2" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "quantity", label: "扣款数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "purchasePrice", label: "采购单价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "purchaseTotalAmount", label: "扣款总价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "抵扣状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterStatus")(scope.row.status))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "settleDate", label: "实际抵扣日期" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fcdeff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fcdeff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/r4SettlementReport/billConfirm/components/detailTable.vue
// module id = null
// module chunks = 